import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class ReportPresenter extends EntityPresenter {
  static urn = 'settings'

  static tree({ nodeId } = {}) {
    return this.get(`nodes`, { nodeId })
  }

  static childrenTree(childrenId) {
    return this.get(`nodes/summary/${ childrenId }`)
  }

  static parentsTree(childrenId) {
    return this.get(`nodes/common/${ childrenId }`)
  }

  static children(childrenId, { nodeId } = {}) {
    return this.get(`nodes/summary/${ childrenId }`, { nodeId })
  }

  // static parents(childrenId, { nodeId } = {}) {
  //   return this.get(`parents/${ childrenId }`, { nodeId })
  // }

  static navOptions(key = 'settings') {
    const routes = {
      settings: {
        icon: 'settings',
        pageRoutes: ['setting'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(ReportPresenter)
